var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{class:[[_vm.$attrs['class'], _vm.gridClasses]],staticStyle:{"flex-grow":"1","overflow":"auto"},attrs:{"id":_vm.$attrs['id'],"srcdoc":_vm.srcdoc,"width":"100%","height":"100%","scrolling":"no"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76ea299c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/util/EmailEditor.vue
// module id = uHDI
// module chunks = 0